/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from "vue-property-decorator";

import {
    getCompanyList,
    setFinanceContractTemplateById, getFinanceContractTemplateById,
    getProjectAllSouCoursePriceList, setFinanceContractTemplate
} from '@/api/financial-center'

import {menuBtn} from '@/utils/menu_level2_button'

import {delNullProperty} from "@/utils";

import E from "wangeditor"

@Component({})
export default class NewContractTemplate extends Vue {
    limit = 20
    tableKey = Math.random()

    formData = {
        detail: '',
        souCourseTypeId: '',
        souCoursePrice: '',
        dissertationType: '',
        companyName: '',
        name: '',
    }

    companyList = []

    disabledButton = false
    saveDraftDialogShow = false
    //
    // isDraft = '0'
    // draftId: number = null // 草稿id

    formRule = {}

    contractTemplateId = null
    isReplace = null


    previewName = ''
    previewVisible = false
    previewPath = ''
    directorUserId = ''


    editor: any = null
    editor2: any = null
    typeList = [
        {value: 1, label: '国外小组科研'},
        {value: 2, label: '国内1对1'},
        {value: 3, label: '国外1对1'},
        {value: 4, label: '名校实验室'},
        {value: 5, label: 'AI HUB'},
        {value: 6, label: '全球华人导师'},
        {value: 27, label: '博雅计划-在线'},
        {value: 30, label: 'IEPQ线上项目'},
        {value: 31, label: '竞赛'},
        {value: 32, label: '全球华人导师-香港'},
        {value: 38, label: '海外导师线下项目'},
        {value: 39, label: '国内导师线下项目'},
        {value: 40, label: '竞赛1v1'},
        {value: 42, label: 'IEPQ 1v1'},
        {value: 44, label: '全球华人导师-海外'},
        {value: 45, label: '企业导师远程实训'},
        {value: 47, label: '博雅计划-线下'},
        {value: 48, label: 'IEPQ 1v3'},
        {value: 49, label: '专业选修课'},
        {value: 50, label: 'IEPQ线下项目'},
        {value: 51, label: 'CERTIPORT认证课程'},
        {value: 52, label: '境外游学项目'},
        {value: 53, label: '竞赛线下（营地）'},
        {value: 54, label: '竞赛线下（研学）'},
    ]
    souCoursePriceList = []

    // get userName() {
    //     return UserModule.userName
    // }
    //
    // get userList() {
    //     return UserModule.userList
    // }
    //
    // get userId() {
    //     return UserModule.userId
    // }


    get baseUrl() {
        let str = '/fileApi/eqianbao/uploadFile'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'eqianbao/uploadFile'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'eqianbao/uploadFile'
            }
        }
        return str
    }

    created() {
        if (this.$route.query.contractTemplateId) {
            this.contractTemplateId = Number(this.$route.query.contractTemplateId)
            this.getFinanceContractTemplateById()
        }

        this.getCompanyList()

    }

    menuBtn = menuBtn

    mounted() {
        this.initEditor()
    }

    // 初始化富文本编辑器
    initEditor() {
        this.editor = new E('#div1')
        this.editor2 = new E('#div2')
        this.editor.config.height = 200
        this.editor2.config.height = 200
        this.editor.config.excludeMenus = [
            'fontName',
            'foreColor',
            'backColor',
            'link',
            'code',
            'splitLine',
            'undo',
            'redo'
        ]
        this.editor2.config.excludeMenus = [
            'fontName',
            'foreColor',
            'backColor',
            'link',
            'code',
            'splitLine',
            'undo',
            'redo'
        ]

        this.editor.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        this.editor2.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        // 隐藏“网络图片”tab
        this.editor.config.showLinkImg = false
        this.editor2.config.showLinkImg = false

        // 创建编辑器
        this.editor.create()
        this.editor2.create()

        // 修改提示信息
        document.getElementsByClassName('placeholder')[0].innerHTML = "请输入正文内容"
        document.getElementsByClassName('placeholder')[1].innerHTML = "请输入附件内容"

        this.editor.txt.html()
        this.editor2.txt.html()

     }

    async changeSouCourseType(val) {
        const data: any = await getProjectAllSouCoursePriceList({
            souCourseTypeId: val
        })
        this.souCoursePriceList = data.souCoursePriceList
    }


    async getFinanceContractTemplateById() {
        this.isReplace = true
        const data: any = await getFinanceContractTemplateById(delNullProperty({
            id: this.contractTemplateId,
        }))
        const {financeContractTemplate} = data
        this.formData = financeContractTemplate

        const a = this.formData.detail.indexOf('</aside>')
        const b = this.formData.detail.lastIndexOf('</main>')
        const c = this.formData.detail.lastIndexOf('</article>')

        const editorHtml  =  this.formData.detail.slice(a,b).substring(8).replace('<aside style="font-family:SourceHanSans;">','')
        editorHtml.replace('</aside>','')
        this.editor.txt.html(editorHtml)
        const editorHtml1 = this.formData.detail.substring(c).substring(10).replace('<aside1 style="font-family:SourceHanSans;">','')
        editorHtml.replace('</aside1>','')
        this.editor2.txt.html(editorHtml1)
    }





    /*保存*/
    clickSubmintButton() {
        // 校验
        const code1 =  document.getElementById('mainTable').innerHTML
        const code5=  document.getElementById('containerMain').innerHTML
        let code2 = '<aside style="font-family:SourceHanSans;">'+this.editor.txt.html()+'</aside>'
        const code3 =  document.getElementById('footerTable').innerHTML
        let code4 = '<aside1 style="font-family:SourceHanSans;">'+this.editor2.txt.html()+'</aside1>'
        code2 = code2.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"');
        code4 = code4.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"')
        this.formData.detail = '<div style="width: 1000px; padding: 0 60px;">'+ code1 + code5+ code2 + code3 + code4+ '</div>'


        const obj = {
            detail: this.formData.detail,
            souCourseTypeId: this.formData.souCourseTypeId,
            souCoursePrice: this.formData.souCoursePrice,
            dissertationType: this.formData.dissertationType,
            companyName: this.formData.companyName,
            name: this.formData.name,

        };
        if (!this.formData.souCourseTypeId) {
            this.$message.error('请选择项目类型')
            return;
        }
        if (!this.formData.souCoursePrice) {
            this.$message.error('请选择项目价格')
            return;
        }
        if (!this.formData.dissertationType) {
            this.$message.error('请选择论文服务类型')
            return;
        }
        if (!this.formData.companyName) {
            this.$message.error('请选择所属公司')
            return;
        }
        if (!this.formData.name) {
            this.$message.error('请填写模板名称')
            return;
        }
        if (!this.formData.detail) {
            this.$message.error('请上传合同')
            return;
        }


        this.disabledButton = true;
        setFinanceContractTemplate(delNullProperty(obj)).then((data) => {
            this.$message.success(`新建成功`)
            this.saveDraftDialogShow = false
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch((err: Error) => {
            if (err) {
                this.disabledButton = false
            }
        })

    }


    /*编辑保存*/
    clickEditSubmitButton() {

        const code1 = document.getElementById('mainTable').innerHTML
        const code5 = document.getElementById('containerMain').innerHTML
        // const code2 = this.editor.txt.html()
        let code2 = '<aside style="font-family:SourceHanSans;">' + this.editor.txt.html() + '</aside>'
        const code3 = document.getElementById('footerTable').innerHTML
        let code4 = '<aside1 style="font-family:SourceHanSans;">' + this.editor2.txt.html() + '</aside1>'
        code2 = code2.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"');
        code4 = code4.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"')
        this.formData.detail = '<div style="width: 1000px; padding: 0 60px;">' + code1 + code5 + code2 + code3 + code4 + '</div>'


        const obj = {
            detail: this.formData.detail,
            souCourseTypeId: this.formData.souCourseTypeId,
            souCoursePrice: this.formData.souCoursePrice,
            dissertationType: this.formData.dissertationType,
            companyName: this.formData.companyName,
            name: this.formData.name,
            id: this.contractTemplateId,
        };
        if (!this.formData.souCourseTypeId) {
            this.$message.error('请选择项目类型')
            return;
        }
        if (!this.formData.souCoursePrice) {
            this.$message.error('请选择项目价格')
            return;
        }
        if (!this.formData.dissertationType) {
            this.$message.error('请选择论文服务类型')
            return;
        }
        if (!this.formData.companyName) {
            this.$message.error('请选择所属公司')
            return;
        }
        if (!this.formData.name) {
            this.$message.error('请填写模板名称')
            return;
        }
        if (!this.formData.detail) {
            this.$message.error('请上传合同')
            return;
        }
        this.disabledButton = true
        setFinanceContractTemplateById(delNullProperty(obj)).then(res => {
            this.$message.success('保存成功，页面即将关闭')
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch(err => {
            this.disabledButton = false
        })
    }


    closePage() {
        window.close()
    }


    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }




}
